var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitProcessesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.74,
    height: 527.87,
    viewBox: "0 0 282.74 527.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_recruit_processes_image",
    transform: "translate(7038.879 -2333.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186045",
    "data-name": "\\uADF8\\uB8F9 186045",
    transform: "translate(-6812.667 2586.996) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184415",
    "data-name": "\\uADF8\\uB8F9 184415",
    transform: "translate(110.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132296",
    "data-name": "\\uD328\\uC2A4 132296",
    d: "M2.827,1.449,0,1.378Q.017.691.018,0H2.845Q2.845.726,2.827,1.449Z",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184416",
    "data-name": "\\uADF8\\uB8F9 184416",
    transform: "translate(0.166 4.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132297",
    "data-name": "\\uD328\\uC2A4 132297",
    d: "M54.975,52.431c-.948-.023-1.91-.071-2.859-.141l.21-2.82c.9.068,1.817.113,2.718.134Zm2.863,0L57.766,49.6c.9-.023,1.818-.069,2.718-.136l.213,2.819C59.75,52.358,58.788,52.406,57.838,52.43ZM49.267,52c-.943-.118-1.9-.262-2.831-.428l.493-2.784c.888.158,1.793.294,2.69.407ZM63.545,52l-.354-2.805c.893-.112,1.8-.25,2.689-.409l.5,2.783C65.439,51.735,64.486,51.881,63.545,52ZM43.63,51c-.927-.213-1.86-.453-2.774-.714l.774-2.719c.869.247,1.755.476,2.634.679Zm25.553-.011-.637-2.755c.876-.2,1.762-.432,2.633-.681l.777,2.718C71.038,50.538,70.105,50.779,69.182,50.993Zm-31.06-1.558c-.9-.307-1.805-.641-2.692-1l1.048-2.626c.843.336,1.7.654,2.557.945Zm36.566-.017-.915-2.675c.853-.292,1.708-.609,2.545-.944l1.05,2.625C76.487,48.778,75.585,49.112,74.688,49.419ZM32.793,47.309c-.869-.4-1.735-.824-2.575-1.264l1.31-2.5c.8.417,1.621.821,2.445,1.2Zm47.2-.013-1.182-2.569c.818-.376,1.638-.78,2.438-1.2l1.311,2.5C81.719,46.476,80.855,46.9,79.994,47.3ZM27.712,44.653c-.819-.483-1.637-.993-2.431-1.518l1.557-2.36c.755.5,1.532.983,2.31,1.442Zm57.349-.008L83.625,42.21c.779-.459,1.554-.943,2.306-1.439l1.558,2.359C86.7,43.652,85.88,44.163,85.061,44.645ZM22.929,41.5c-.765-.562-1.527-1.152-2.265-1.754l1.787-2.191c.7.572,1.426,1.133,2.152,1.667Zm66.907,0-1.675-2.277c.729-.536,1.453-1.1,2.15-1.666L92.1,39.742C91.365,40.34,90.6,40.93,89.836,41.494ZM18.491,37.878c-.707-.638-1.406-1.3-2.077-1.974l2-2c.638.638,1.3,1.268,1.972,1.875Zm75.78,0-1.9-2.1c.672-.606,1.335-1.237,1.973-1.875l2,2C95.675,36.576,94.977,37.239,94.27,37.877ZM14.44,33.831c-.638-.7-1.266-1.435-1.867-2.17l2.189-1.789c.571.7,1.168,1.392,1.773,2.062Zm83.88,0-2.1-1.9c.607-.671,1.2-1.366,1.775-2.064l2.19,1.79C99.588,32.394,98.96,33.124,98.32,33.831ZM10.819,29.4c-.563-.763-1.114-1.552-1.638-2.346l2.358-1.559c.5.753,1.022,1.5,1.556,2.229Zm91.124,0-2.276-1.677c.534-.724,1.058-1.476,1.558-2.232l2.359,1.559C103.058,27.842,102.506,28.632,101.944,29.4ZM7.663,24.628c-.485-.82-.953-1.66-1.392-2.5l2.5-1.313c.418.8.863,1.594,1.323,2.374Zm97.441-.013-2.435-1.437c.461-.781.907-1.582,1.325-2.381l2.5,1.313C106.059,22.951,105.59,23.793,105.1,24.615ZM5.008,19.564c-.4-.865-.78-1.749-1.131-2.626L6.5,15.887c.334.833.695,1.672,1.074,2.494Zm102.757-.028L105.2,18.354c.379-.821.741-1.664,1.077-2.5L108.9,16.9C108.545,17.785,108.164,18.672,107.765,19.537ZM2.879,14.255c-.308-.9-.6-1.819-.859-2.732l2.718-.78c.249.868.523,1.741.816,2.6ZM109.9,14.21l-2.675-.915c.293-.857.568-1.732.816-2.6l2.719.777C110.494,12.386,110.205,13.307,109.9,14.21ZM1.3,8.75C1.085,7.823.891,6.878.723,5.944l2.784-.5c.158.887.343,1.783.548,2.664ZM111.472,8.7l-2.755-.637c.2-.88.387-1.776.545-2.665l2.784.5C111.88,6.827,111.687,7.771,111.472,8.7ZM.29,3.114C.169,2.167.071,1.209,0,.265L2.819.051c.068.9.16,1.807.275,2.706Zm112.188-.053-2.805-.354c.113-.9.2-1.807.273-2.707l2.819.212C112.692,1.16,112.6,2.118,112.478,3.061Z",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184417",
    "data-name": "\\uADF8\\uB8F9 184417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132298",
    "data-name": "\\uD328\\uC2A4 132298",
    d: "M.018,1.449Q0,.727,0,0H2.827q0,.691.018,1.378Z",
    fill: "#282d34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186052",
    "data-name": "\\uADF8\\uB8F9 186052",
    transform: "translate(-7038.879 2699.075) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184415-2",
    "data-name": "\\uADF8\\uB8F9 184415",
    transform: "translate(110.248 55.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132296-2",
    "data-name": "\\uD328\\uC2A4 132296",
    d: "M2.827,0,0,.071Q.017.758.018,1.449H2.845Q2.845.723,2.827,0Z",
    transform: "translate(0 0)",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184416-2",
    "data-name": "\\uADF8\\uB8F9 184416",
    transform: "translate(0.166 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132297-2",
    "data-name": "\\uD328\\uC2A4 132297",
    d: "M54.975,0c-.948.023-1.91.071-2.859.141l.21,2.82c.9-.068,1.817-.113,2.718-.134Zm2.863,0-.071,2.827c.9.023,1.818.069,2.718.136L60.7.145C59.75.073,58.788.025,57.838,0ZM49.267.426c-.943.118-1.9.262-2.831.428l.493,2.784c.889-.158,1.793-.294,2.69-.407ZM63.545.432l-.354,2.805c.893.112,1.8.25,2.689.409l.5-2.783C65.439.7,64.486.551,63.545.432ZM43.63,1.426c-.927.213-1.86.453-2.774.714l.774,2.719c.869-.247,1.755-.476,2.634-.679Zm25.553.011-.637,2.755c.876.2,1.762.432,2.633.681l.777-2.718C71.038,1.893,70.105,1.652,69.182,1.438ZM38.122,3c-.9.307-1.805.641-2.692,1l1.048,2.626c.843-.336,1.7-.654,2.557-.945Zm36.566.017-.915,2.675c.853.292,1.708.609,2.545.944l1.05-2.625C76.487,3.654,75.585,3.319,74.688,3.013ZM32.793,5.122c-.869.4-1.735.824-2.575,1.264l1.31,2.5c.8-.417,1.621-.821,2.445-1.2Zm47.2.013L78.812,7.7c.818.376,1.638.78,2.438,1.2l1.311-2.5C81.719,5.955,80.855,5.531,79.994,5.134ZM27.712,7.778c-.819.483-1.637.993-2.431,1.518l1.557,2.36c.755-.5,1.532-.983,2.31-1.442Zm57.349.008-1.436,2.436c.779.459,1.554.943,2.306,1.439L87.488,9.3C86.7,8.779,85.88,8.269,85.061,7.786ZM22.929,10.933c-.765.562-1.527,1.152-2.265,1.754l1.787,2.191c.7-.572,1.426-1.133,2.152-1.667Zm66.907,0-1.675,2.277c.729.536,1.453,1.1,2.15,1.666L92.1,12.689C91.365,12.091,90.6,11.5,89.836,10.937ZM18.491,14.553c-.707.638-1.406,1.3-2.077,1.974l2,2c.638-.638,1.3-1.268,1.972-1.875Zm75.78,0-1.9,2.1c.672.606,1.335,1.237,1.973,1.875l2-2C95.675,15.856,94.976,15.192,94.27,14.554ZM14.44,18.6c-.638.7-1.266,1.435-1.867,2.17l2.189,1.789c.571-.7,1.168-1.392,1.773-2.062Zm83.88,0-2.1,1.9c.607.671,1.2,1.366,1.775,2.064l2.19-1.79C99.588,20.037,98.96,19.307,98.32,18.6Zm-87.5,4.431c-.563.763-1.114,1.552-1.638,2.346l2.358,1.559c.5-.753,1.022-1.5,1.556-2.229Zm91.124,0-2.276,1.677c.534.724,1.058,1.476,1.558,2.232l2.359-1.559C103.058,24.589,102.506,23.8,101.944,23.035ZM7.663,27.8c-.485.82-.953,1.66-1.392,2.5l2.5,1.313c.418-.8.863-1.594,1.323-2.374Zm97.441.013-2.435,1.437c.461.781.907,1.582,1.325,2.381l2.5-1.313C106.059,29.481,105.59,28.638,105.1,27.816ZM5.008,32.867c-.4.865-.78,1.749-1.131,2.626L6.5,36.545c.334-.833.695-1.672,1.074-2.494Zm102.757.028L105.2,34.078c.379.821.741,1.664,1.077,2.5l2.625-1.05C108.545,34.646,108.164,33.76,107.765,32.895ZM2.879,38.177c-.308.9-.6,1.819-.859,2.732l2.718.78c.249-.868.523-1.741.816-2.6Zm107.017.045-2.675.915c.293.857.568,1.732.816,2.6l2.719-.777C110.494,40.045,110.205,39.124,109.9,38.221ZM1.3,43.681c-.215.927-.409,1.872-.577,2.805l2.784.5c.158-.887.343-1.783.548-2.664Zm110.173.052-2.755.637c.2.88.387,1.776.545,2.665l2.783-.5C111.88,45.6,111.687,44.66,111.472,43.734ZM.29,49.317c-.121.947-.218,1.906-.29,2.849l2.819.214c.068-.9.16-1.807.275-2.706Zm112.188.053-2.805.354c.113.9.2,1.807.273,2.707l2.819-.212C112.692,51.271,112.6,50.314,112.478,49.37Z",
    transform: "translate(0 0)",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184417-2",
    "data-name": "\\uADF8\\uB8F9 184417",
    transform: "translate(0 55.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132298-2",
    "data-name": "\\uD328\\uC2A4 132298",
    d: "M.018,0Q0,.722,0,1.449H2.827q0-.691.018-1.378Z",
    transform: "translate(0 0)",
    fill: "#282d34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186043",
    "data-name": "\\uADF8\\uB8F9 186043",
    transform: "translate(-6812.667 2809.821) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184415-3",
    "data-name": "\\uADF8\\uB8F9 184415",
    transform: "translate(110.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132296-3",
    "data-name": "\\uD328\\uC2A4 132296",
    d: "M2.827,1.449,0,1.378Q.017.691.018,0H2.845Q2.845.726,2.827,1.449Z",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184416-3",
    "data-name": "\\uADF8\\uB8F9 184416",
    transform: "translate(0.166 4.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132297-3",
    "data-name": "\\uD328\\uC2A4 132297",
    d: "M54.975,52.431c-.948-.023-1.91-.071-2.859-.141l.21-2.82c.9.068,1.817.113,2.718.134Zm2.863,0L57.766,49.6c.9-.023,1.818-.069,2.718-.136l.213,2.819C59.75,52.358,58.788,52.406,57.838,52.43ZM49.267,52c-.943-.118-1.9-.262-2.831-.428l.493-2.784c.888.158,1.793.294,2.69.407ZM63.545,52l-.354-2.805c.893-.112,1.8-.25,2.689-.409l.5,2.783C65.439,51.735,64.486,51.881,63.545,52ZM43.63,51c-.927-.213-1.86-.453-2.774-.714l.774-2.719c.869.247,1.755.476,2.634.679Zm25.553-.011-.637-2.755c.876-.2,1.762-.432,2.633-.681l.777,2.718C71.038,50.538,70.105,50.779,69.182,50.993Zm-31.06-1.558c-.9-.307-1.805-.641-2.692-1l1.048-2.626c.843.336,1.7.654,2.557.945Zm36.566-.017-.915-2.675c.853-.292,1.708-.609,2.545-.944l1.05,2.625C76.487,48.778,75.585,49.112,74.688,49.419ZM32.793,47.309c-.869-.4-1.735-.824-2.575-1.264l1.31-2.5c.8.417,1.621.821,2.445,1.2Zm47.2-.013-1.182-2.569c.818-.376,1.638-.78,2.438-1.2l1.311,2.5C81.719,46.476,80.855,46.9,79.994,47.3ZM27.712,44.653c-.819-.483-1.637-.993-2.431-1.518l1.557-2.36c.755.5,1.532.983,2.31,1.442Zm57.349-.008L83.625,42.21c.779-.459,1.554-.943,2.306-1.439l1.558,2.359C86.7,43.652,85.88,44.163,85.061,44.645ZM22.929,41.5c-.765-.562-1.527-1.152-2.265-1.754l1.787-2.191c.7.572,1.426,1.133,2.152,1.667Zm66.907,0-1.675-2.277c.729-.536,1.453-1.1,2.15-1.666L92.1,39.742C91.365,40.34,90.6,40.93,89.836,41.494ZM18.491,37.878c-.707-.638-1.406-1.3-2.077-1.974l2-2c.638.638,1.3,1.268,1.972,1.875Zm75.78,0-1.9-2.1c.672-.606,1.335-1.237,1.973-1.875l2,2C95.675,36.576,94.977,37.239,94.27,37.877ZM14.44,33.831c-.638-.7-1.266-1.435-1.867-2.17l2.189-1.789c.571.7,1.168,1.392,1.773,2.062Zm83.88,0-2.1-1.9c.607-.671,1.2-1.366,1.775-2.064l2.19,1.79C99.588,32.394,98.96,33.124,98.32,33.831ZM10.819,29.4c-.563-.763-1.114-1.552-1.638-2.346l2.358-1.559c.5.753,1.022,1.5,1.556,2.229Zm91.124,0-2.276-1.677c.534-.724,1.058-1.476,1.558-2.232l2.359,1.559C103.058,27.842,102.506,28.632,101.944,29.4ZM7.663,24.628c-.485-.82-.953-1.66-1.392-2.5l2.5-1.313c.418.8.863,1.594,1.323,2.374Zm97.441-.013-2.435-1.437c.461-.781.907-1.582,1.325-2.381l2.5,1.313C106.059,22.951,105.59,23.793,105.1,24.615ZM5.008,19.564c-.4-.865-.78-1.749-1.131-2.626L6.5,15.887c.334.833.695,1.672,1.074,2.494Zm102.757-.028L105.2,18.354c.379-.821.741-1.664,1.077-2.5L108.9,16.9C108.545,17.785,108.164,18.672,107.765,19.537ZM2.879,14.255c-.308-.9-.6-1.819-.859-2.732l2.718-.78c.249.868.523,1.741.816,2.6ZM109.9,14.21l-2.675-.915c.293-.857.568-1.732.816-2.6l2.719.777C110.494,12.386,110.205,13.307,109.9,14.21ZM1.3,8.75C1.085,7.823.891,6.878.723,5.944l2.784-.5c.158.887.343,1.783.548,2.664ZM111.472,8.7l-2.755-.637c.2-.88.387-1.776.545-2.665l2.784.5C111.88,6.827,111.687,7.771,111.472,8.7ZM.29,3.114C.169,2.167.071,1.209,0,.265L2.819.051c.068.9.16,1.807.275,2.706Zm112.188-.053-2.805-.354c.113-.9.2-1.807.273-2.707l2.819.212C112.692,1.16,112.6,2.118,112.478,3.061Z",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184417-3",
    "data-name": "\\uADF8\\uB8F9 184417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132298-3",
    "data-name": "\\uD328\\uC2A4 132298",
    d: "M.018,1.449Q0,.727,0,0H2.827q0,.691.018,1.378Z",
    fill: "#282d34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186053",
    "data-name": "\\uADF8\\uB8F9 186053",
    transform: "translate(-7038.879 2482.815) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184415-4",
    "data-name": "\\uADF8\\uB8F9 184415",
    transform: "translate(110.248 55.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132296-4",
    "data-name": "\\uD328\\uC2A4 132296",
    d: "M2.827,0,0,.071Q.017.758.018,1.449H2.845Q2.845.723,2.827,0Z",
    transform: "translate(0 0)",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184416-4",
    "data-name": "\\uADF8\\uB8F9 184416",
    transform: "translate(0.166 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132297-4",
    "data-name": "\\uD328\\uC2A4 132297",
    d: "M54.975,0c-.948.023-1.91.071-2.859.141l.21,2.82c.9-.068,1.817-.113,2.718-.134Zm2.863,0-.071,2.827c.9.023,1.818.069,2.718.136L60.7.145C59.75.073,58.788.025,57.838,0ZM49.267.426c-.943.118-1.9.262-2.831.428l.493,2.784c.889-.158,1.793-.294,2.69-.407ZM63.545.432l-.354,2.805c.893.112,1.8.25,2.689.409l.5-2.783C65.439.7,64.486.551,63.545.432ZM43.63,1.426c-.927.213-1.86.453-2.774.714l.774,2.719c.869-.247,1.755-.476,2.634-.679Zm25.553.011-.637,2.755c.876.2,1.762.432,2.633.681l.777-2.718C71.038,1.893,70.105,1.652,69.182,1.438ZM38.122,3c-.9.307-1.805.641-2.692,1l1.048,2.626c.843-.336,1.7-.654,2.557-.945Zm36.566.017-.915,2.675c.853.292,1.708.609,2.545.944l1.05-2.625C76.487,3.654,75.585,3.319,74.688,3.013ZM32.793,5.122c-.869.4-1.735.824-2.575,1.264l1.31,2.5c.8-.417,1.621-.821,2.445-1.2Zm47.2.013L78.812,7.7c.818.376,1.638.78,2.438,1.2l1.311-2.5C81.719,5.955,80.855,5.531,79.994,5.134ZM27.712,7.778c-.819.483-1.637.993-2.431,1.518l1.557,2.36c.755-.5,1.532-.983,2.31-1.442Zm57.349.008-1.436,2.436c.779.459,1.554.943,2.306,1.439L87.488,9.3C86.7,8.779,85.88,8.269,85.061,7.786ZM22.929,10.933c-.765.562-1.527,1.152-2.265,1.754l1.787,2.191c.7-.572,1.426-1.133,2.152-1.667Zm66.907,0-1.675,2.277c.729.536,1.453,1.1,2.15,1.666L92.1,12.689C91.365,12.091,90.6,11.5,89.836,10.937ZM18.491,14.553c-.707.638-1.406,1.3-2.077,1.974l2,2c.638-.638,1.3-1.268,1.972-1.875Zm75.78,0-1.9,2.1c.672.606,1.335,1.237,1.973,1.875l2-2C95.675,15.856,94.976,15.192,94.27,14.554ZM14.44,18.6c-.638.7-1.266,1.435-1.867,2.17l2.189,1.789c.571-.7,1.168-1.392,1.773-2.062Zm83.88,0-2.1,1.9c.607.671,1.2,1.366,1.775,2.064l2.19-1.79C99.588,20.037,98.96,19.307,98.32,18.6Zm-87.5,4.431c-.563.763-1.114,1.552-1.638,2.346l2.358,1.559c.5-.753,1.022-1.5,1.556-2.229Zm91.124,0-2.276,1.677c.534.724,1.058,1.476,1.558,2.232l2.359-1.559C103.058,24.589,102.506,23.8,101.944,23.035ZM7.663,27.8c-.485.82-.953,1.66-1.392,2.5l2.5,1.313c.418-.8.863-1.594,1.323-2.374Zm97.441.013-2.435,1.437c.461.781.907,1.582,1.325,2.381l2.5-1.313C106.059,29.481,105.59,28.638,105.1,27.816ZM5.008,32.867c-.4.865-.78,1.749-1.131,2.626L6.5,36.545c.334-.833.695-1.672,1.074-2.494Zm102.757.028L105.2,34.078c.379.821.741,1.664,1.077,2.5l2.625-1.05C108.545,34.646,108.164,33.76,107.765,32.895ZM2.879,38.177c-.308.9-.6,1.819-.859,2.732l2.718.78c.249-.868.523-1.741.816-2.6Zm107.017.045-2.675.915c.293.857.568,1.732.816,2.6l2.719-.777C110.494,40.045,110.205,39.124,109.9,38.221ZM1.3,43.681c-.215.927-.409,1.872-.577,2.805l2.784.5c.158-.887.343-1.783.548-2.664Zm110.173.052-2.755.637c.2.88.387,1.776.545,2.665l2.783-.5C111.88,45.6,111.687,44.66,111.472,43.734ZM.29,49.317c-.121.947-.218,1.906-.29,2.849l2.819.214c.068-.9.16-1.807.275-2.706Zm112.188.053-2.805.354c.113.9.2,1.807.273,2.707l2.819-.212C112.692,51.271,112.6,50.314,112.478,49.37Z",
    transform: "translate(0 0)",
    fill: "#282d34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184417-4",
    "data-name": "\\uADF8\\uB8F9 184417",
    transform: "translate(0 55.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132298-4",
    "data-name": "\\uD328\\uC2A4 132298",
    d: "M.018,0Q0,.722,0,1.449H2.827q0-.691.018-1.378Z",
    transform: "translate(0 0)",
    fill: "#282d34"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139009",
    "data-name": "\\uD328\\uC2A4 139009",
    d: "M-7352.274,2490.075h93.743",
    transform: "translate(412.331 -16.064)",
    fill: "none",
    stroke: "#282d34",
    strokeWidth: 3,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139008",
    "data-name": "\\uD328\\uC2A4 139008",
    d: "M-7352.274,2490.075h101.785",
    transform: "translate(399.186 95.908)",
    fill: "none",
    stroke: "#282d34",
    strokeWidth: 3,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139007",
    "data-name": "\\uD328\\uC2A4 139007",
    d: "M-7352.274,2490.075h101.034",
    transform: "translate(405.04 207.881)",
    fill: "none",
    stroke: "#282d34",
    strokeWidth: 3,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139006",
    "data-name": "\\uD328\\uC2A4 139006",
    d: "M-7352.274,2490.075h101.034",
    transform: "translate(405.04 319.746)",
    fill: "none",
    stroke: "#282d34",
    strokeWidth: 3,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186051",
    "data-name": "\\uADF8\\uB8F9 186051",
    transform: "translate(-6999.478 2333.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184514",
    "data-name": "\\uADF8\\uB8F9 184514",
    transform: "translate(0 19.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184509",
    "data-name": "\\uADF8\\uB8F9 184509",
    transform: "translate(0.058 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132355",
    "data-name": "\\uD328\\uC2A4 132355",
    d: "M497.863,365.82H504v31.689h-57.17V365.82h51.034Z",
    transform: "translate(-445.676 -364.667)",
    fill: "#ffcc45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132356",
    "data-name": "\\uD328\\uC2A4 132356",
    d: "M504.306,397.816H444.829v-34h6.989v2.307h-4.682v29.382H502V366.127h-4.983V363.82h7.29Z",
    transform: "translate(-444.829 -363.82)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184512",
    "data-name": "\\uADF8\\uB8F9 184512",
    transform: "translate(0.665 16.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184510",
    "data-name": "\\uADF8\\uB8F9 184510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154225",
    "data-name": "\\uC0AC\\uAC01\\uD615 154225",
    width: 23.138,
    height: 2.307,
    transform: "translate(0 15.61) rotate(-42.428)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184511",
    "data-name": "\\uADF8\\uB8F9 184511",
    transform: "translate(39.627 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154226",
    "data-name": "\\uC0AC\\uAC01\\uD615 154226",
    width: 2.307,
    height: 23.136,
    transform: "translate(0 1.703) rotate(-47.576)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184513",
    "data-name": "\\uADF8\\uB8F9 184513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132357",
    "data-name": "\\uD328\\uC2A4 132357",
    d: "M503.945,365.82H446.728v1.966h-.012l.012.012v.009h.014l7.127,6.079,5.019,4.282c.591.5,1.362,1.16,2.135,1.822l6.681,5.7,5.495,4.686a3.415,3.415,0,0,0,4.271,0l5.493-4.686,6.681-5.7c.773-.662,1.546-1.322,2.133-1.822l5.019-4.282,7.128-6.079h.02v-.017l.006,0h-.006Z",
    transform: "translate(-445.57 -364.667)",
    fill: "#ffe08e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132358",
    "data-name": "\\uD328\\uC2A4 132358",
    d: "M474.494,391.429a4.439,4.439,0,0,1-2.885-1.025l-12.287-10.477c-.735-.629-1.46-1.249-2.022-1.725l-12.087-10.31a1.178,1.178,0,0,1-.48-1.055v-1.863a1.154,1.154,0,0,1,1.153-1.153H503.1a1.153,1.153,0,0,1,1.153,1.153v1.877a1.154,1.154,0,0,1-.159.683,1.187,1.187,0,0,1-.361.386L491.685,378.2c-.587.5-1.359,1.16-2.131,1.821L477.377,390.4A4.431,4.431,0,0,1,474.494,391.429ZM447.04,366.417l11.754,10.027c.561.475,1.289,1.1,2.027,1.729l12.283,10.474a2.355,2.355,0,0,0,2.775,0l12.175-10.381c.773-.661,1.546-1.322,2.134-1.822l11.761-10.032v-.285H447.04Z",
    transform: "translate(-444.729 -363.82)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184525",
    "data-name": "\\uADF8\\uB8F9 184525",
    transform: "translate(10.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184515",
    "data-name": "\\uADF8\\uB8F9 184515",
    transform: "translate(18.012)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154227",
    "data-name": "\\uC0AC\\uAC01\\uD615 154227",
    width: 2.307,
    height: 5.231,
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184516",
    "data-name": "\\uADF8\\uB8F9 184516",
    transform: "translate(8.649 0.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154228",
    "data-name": "\\uC0AC\\uAC01\\uD615 154228",
    width: 2.306,
    height: 5.232,
    transform: "translate(0 0.597) rotate(-15.002)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184517",
    "data-name": "\\uADF8\\uB8F9 184517",
    transform: "translate(0.002 4.29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154229",
    "data-name": "\\uC0AC\\uAC01\\uD615 154229",
    width: 2.307,
    height: 5.232,
    transform: "translate(0 1.153) rotate(-29.998)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184518",
    "data-name": "\\uADF8\\uB8F9 184518",
    transform: "translate(0 62.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154230",
    "data-name": "\\uC0AC\\uAC01\\uD615 154230",
    width: 5.232,
    height: 2.306,
    transform: "translate(0 4.53) rotate(-59.979)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184519",
    "data-name": "\\uADF8\\uB8F9 184519",
    transform: "translate(8.645 66.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154231",
    "data-name": "\\uC0AC\\uAC01\\uD615 154231",
    width: 5.231,
    height: 2.307,
    transform: "translate(0 5.052) rotate(-74.987)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184520",
    "data-name": "\\uADF8\\uB8F9 184520",
    transform: "translate(18.01 67.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154232",
    "data-name": "\\uC0AC\\uAC01\\uD615 154232",
    width: 2.307,
    height: 5.232,
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184521",
    "data-name": "\\uADF8\\uB8F9 184521",
    transform: "translate(26.098 66.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154233",
    "data-name": "\\uC0AC\\uAC01\\uD615 154233",
    width: 2.306,
    height: 5.231,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 0.597)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184522",
    "data-name": "\\uADF8\\uB8F9 184522",
    transform: "translate(33.714 62.686)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154234",
    "data-name": "\\uC0AC\\uAC01\\uD615 154234",
    width: 2.307,
    height: 5.23,
    transform: "translate(0 1.153) rotate(-29.988)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184523",
    "data-name": "\\uADF8\\uB8F9 184523",
    transform: "translate(33.718 4.291)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154235",
    "data-name": "\\uC0AC\\uAC01\\uD615 154235",
    width: 5.231,
    height: 2.307,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 4.531)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184524",
    "data-name": "\\uADF8\\uB8F9 184524",
    transform: "translate(26.102 0.941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154236",
    "data-name": "\\uC0AC\\uAC01\\uD615 154236",
    width: 5.231,
    height: 2.306,
    transform: "translate(0 5.053) rotate(-75.013)",
    fill: "#282d33"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186042",
    "data-name": "\\uADF8\\uB8F9 186042",
    transform: "translate(-6855.335 2668.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165663",
    "data-name": "\\uADF8\\uB8F9 165663",
    transform: "translate(1.46 1.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117494",
    "data-name": "\\uD328\\uC2A4 117494",
    d: "M589.834,465.944a27.926,27.926,0,1,1,27.926-27.927Z",
    transform: "translate(-561.908 -410.091)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185101",
    "data-name": "\\uADF8\\uB8F9 185101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185102",
    "data-name": "\\uADF8\\uB8F9 185102"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21791",
    "data-name": "\\uD0C0\\uC6D0 21791",
    cx: 29.584,
    cy: 29.584,
    r: 29.584,
    transform: "translate(0.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117495",
    "data-name": "\\uD328\\uC2A4 117495",
    d: "M589.493,467.262a29.585,29.585,0,1,1,29.585-29.586H615.76a26.267,26.267,0,1,0-26.267,26.268Z",
    transform: "translate(-559.908 -408.014)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165667",
    "data-name": "\\uADF8\\uB8F9 165667",
    transform: "translate(29.386 29.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165664",
    "data-name": "\\uADF8\\uB8F9 165664",
    transform: "translate(26.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117496",
    "data-name": "\\uD328\\uC2A4 117496",
    d: "M630.5,445.514l-3.312-.2q.046-.775.046-1.561h3.318Q630.549,444.642,630.5,445.514Z",
    transform: "translate(-627.185 -443.757)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165665",
    "data-name": "\\uADF8\\uB8F9 165665",
    transform: "translate(4.49 4.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117497",
    "data-name": "\\uD328\\uC2A4 117497",
    d: "M601.55,473.834l-.563-3.271a25.845,25.845,0,0,0,2.854-.658l.927,3.186A29.467,29.467,0,0,1,601.55,473.834Zm6.332-1.842L606.6,468.93a26.386,26.386,0,0,0,2.635-1.277l1.612,2.9A29.555,29.555,0,0,1,607.883,471.993Zm5.759-3.2-1.925-2.7a26.575,26.575,0,0,0,2.29-1.831l2.212,2.473A29.849,29.849,0,0,1,613.642,468.792Zm4.911-4.395-2.472-2.212a26.288,26.288,0,0,0,1.83-2.29l2.7,1.924A29.709,29.709,0,0,1,618.553,464.4Zm3.823-5.371-2.9-1.611a26.2,26.2,0,0,0,1.278-2.639l3.063,1.277A29.446,29.446,0,0,1,622.376,459.026Zm2.537-6.089-3.186-.926a26.058,26.058,0,0,0,.658-2.857l3.27.562A29.486,29.486,0,0,1,624.913,452.938Z",
    transform: "translate(-600.987 -449.155)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165666",
    "data-name": "\\uADF8\\uB8F9 165666",
    transform: "translate(0 26.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117498",
    "data-name": "\\uD328\\uC2A4 117498",
    d: "M595.574,478.733v-3.318c.524,0,1.044-.014,1.559-.046l.2,3.312Q596.46,478.733,595.574,478.733Z",
    transform: "translate(-595.574 -475.369)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117499",
    "data-name": "\\uD328\\uC2A4 117499",
    d: "M611.379,439.668a19.893,19.893,0,1,1-19.894-19.894A19.9,19.9,0,0,1,611.379,439.668Z",
    transform: "translate(-562.1 -410.005)",
    fill: "#d2e855"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165668",
    "data-name": "\\uADF8\\uB8F9 165668",
    transform: "translate(12.677 14.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117500",
    "data-name": "\\uD328\\uC2A4 117500",
    d: "M607.431,434.132l-5.46-5.463-14.046,14.046L583.71,438.5l-5.46,5.461,9.611,9.738Z",
    transform: "translate(-575.912 -426.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117501",
    "data-name": "\\uD328\\uC2A4 117501",
    d: "M587.373,455.573l-11.942-12.1,7.8-7.8,4.216,4.215,14.047-14.046,7.806,7.809Zm-7.265-12.085,7.28,7.377,17.218-17.215-3.115-3.116-14.046,14.046-4.215-4.215Z",
    transform: "translate(-575.431 -425.841)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186046",
    "data-name": "\\uADF8\\uB8F9 186046",
    transform: "translate(-6855.335 2444.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185099",
    "data-name": "\\uADF8\\uB8F9 185099"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21791-2",
    "data-name": "\\uD0C0\\uC6D0 21791",
    cx: 29.584,
    cy: 29.584,
    r: 29.584,
    transform: "translate(0.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117495-2",
    "data-name": "\\uD328\\uC2A4 117495",
    d: "M589.493,467.262a29.585,29.585,0,1,1,29.585-29.586H615.76a26.267,26.267,0,1,0-26.267,26.268Z",
    transform: "translate(-559.908 -408.013)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185100",
    "data-name": "\\uADF8\\uB8F9 185100",
    transform: "translate(29.585 29.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165664-2",
    "data-name": "\\uADF8\\uB8F9 165664",
    transform: "translate(26.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117496-2",
    "data-name": "\\uD328\\uC2A4 117496",
    d: "M630.5,445.514l-3.312-.2q.046-.775.046-1.561h3.318Q630.549,444.642,630.5,445.514Z",
    transform: "translate(-627.185 -443.757)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165665-2",
    "data-name": "\\uADF8\\uB8F9 165665",
    transform: "translate(4.49 4.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117497-2",
    "data-name": "\\uD328\\uC2A4 117497",
    d: "M601.55,473.834l-.563-3.271a25.845,25.845,0,0,0,2.854-.658l.927,3.186A29.467,29.467,0,0,1,601.55,473.834Zm6.332-1.842L606.6,468.93a26.386,26.386,0,0,0,2.635-1.277l1.612,2.9A29.555,29.555,0,0,1,607.883,471.993Zm5.759-3.2-1.925-2.7a26.575,26.575,0,0,0,2.29-1.831l2.212,2.473A29.849,29.849,0,0,1,613.642,468.792Zm4.911-4.395-2.472-2.212a26.288,26.288,0,0,0,1.83-2.29l2.7,1.924A29.709,29.709,0,0,1,618.553,464.4Zm3.823-5.371-2.9-1.611a26.2,26.2,0,0,0,1.278-2.639l3.063,1.277A29.446,29.446,0,0,1,622.376,459.026Zm2.537-6.089-3.186-.926a26.058,26.058,0,0,0,.658-2.857l3.27.562A29.486,29.486,0,0,1,624.913,452.938Z",
    transform: "translate(-600.987 -449.155)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165666-2",
    "data-name": "\\uADF8\\uB8F9 165666",
    transform: "translate(0 26.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117498-2",
    "data-name": "\\uD328\\uC2A4 117498",
    d: "M595.574,478.733v-3.318c.524,0,1.044-.014,1.559-.046l.2,3.312Q596.46,478.733,595.574,478.733Z",
    transform: "translate(-595.574 -475.369)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185025",
    "data-name": "\\uADF8\\uB8F9 185025",
    transform: "translate(7.617 7.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132624",
    "data-name": "\\uD328\\uC2A4 132624",
    d: "M530.578,278.482a22.166,22.166,0,1,1-22.167-22.167A22.166,22.166,0,0,1,530.578,278.482Z",
    transform: "translate(-486.246 -256.315)",
    fill: "#ffddf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185024",
    "data-name": "\\uADF8\\uB8F9 185024",
    transform: "translate(6.339 6.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185021",
    "data-name": "\\uADF8\\uB8F9 185021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132625",
    "data-name": "\\uD328\\uC2A4 132625",
    d: "M510.72,296.647A15.878,15.878,0,1,1,523,270.709l-2.282,1.87a12.927,12.927,0,1,0-2.211,18.506l1.779,2.353A15.741,15.741,0,0,1,510.72,296.647Z",
    transform: "translate(-494.84 -264.89)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185022",
    "data-name": "\\uADF8\\uB8F9 185022",
    transform: "translate(6.891 7.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132626",
    "data-name": "\\uD328\\uC2A4 132626",
    d: "M510.568,291.267h0a7.212,7.212,0,0,1-1.985-.3,6.12,6.12,0,0,1-4.175-4.6,9.362,9.362,0,0,1,2.948-8.9,10.648,10.648,0,0,1,7.458-2.549,15.864,15.864,0,0,1,3.224.318l1.544.352-.461,1.517c-.107.348-2.609,8.555-3.058,9.839C515.127,289.651,513.072,291.267,510.568,291.267Zm4.247-13.393a7.99,7.99,0,0,0-5.437,1.749,6.383,6.383,0,0,0-2.1,6.055,3.17,3.17,0,0,0,2.122,2.455,4.25,4.25,0,0,0,1.17.183,2.978,2.978,0,0,0,2.71-2.338c.311-.89,1.737-5.532,2.514-8.07C515.494,277.888,515.164,277.874,514.815,277.874Z",
    transform: "translate(-504.182 -274.923)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185023",
    "data-name": "\\uADF8\\uB8F9 185023",
    transform: "translate(17.14 3.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132627",
    "data-name": "\\uD328\\uC2A4 132627",
    d: "M522.883,289.658a5.434,5.434,0,0,1-3.713-1.415c-2.118-1.925-.688-8.333.353-11.981l2.838.809c-1.138,3.994-1.68,8.22-1.158,9.041a2.881,2.881,0,0,0,2.932.37,7.934,7.934,0,0,0,4.77-5.982c.381-2.206-.041-5.532-4.213-8.858l1.84-2.307c5.58,4.45,5.7,9.22,5.282,11.668a10.907,10.907,0,0,1-6.719,8.271A6.806,6.806,0,0,1,522.883,289.658Z",
    transform: "translate(-518.077 -269.335)",
    fill: "#282d33"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21989",
    "data-name": "\\uD0C0\\uC6D0 21989",
    cx: 51.165,
    cy: 51.165,
    r: 51.165,
    transform: "translate(-7020.875 2422.279)",
    fill: "#ffeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21775_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21775 - \\uC724\\uACFD\\uC120",
    d: "M51.165,1.94a49.6,49.6,0,0,0-9.923,1,48.945,48.945,0,0,0-17.6,7.406A49.374,49.374,0,0,0,5.807,32.005,48.963,48.963,0,0,0,2.94,41.242a49.724,49.724,0,0,0,0,19.845,48.945,48.945,0,0,0,7.406,17.6A49.374,49.374,0,0,0,32.005,96.523a48.964,48.964,0,0,0,9.237,2.867,49.725,49.725,0,0,0,19.845,0,48.945,48.945,0,0,0,17.6-7.406A49.374,49.374,0,0,0,96.523,70.325a48.964,48.964,0,0,0,2.867-9.237,49.725,49.725,0,0,0,0-19.845,48.945,48.945,0,0,0-7.406-17.6A49.374,49.374,0,0,0,70.325,5.807,48.963,48.963,0,0,0,61.088,2.94a49.6,49.6,0,0,0-9.923-1m0-1.94A51.165,51.165,0,1,1,0,51.165,51.165,51.165,0,0,1,51.165,0Z",
    transform: "translate(-7020.875 2422.279)",
    fill: "#243242"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21987",
    "data-name": "\\uD0C0\\uC6D0 21987",
    cx: 51.165,
    cy: 51.165,
    r: 51.165,
    transform: "translate(-6876.891 2758.933)",
    fill: "#ffeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21775_-_\\uC724\\uACFD\\uC120-2",
    "data-name": "\\uD0C0\\uC6D0 21775 - \\uC724\\uACFD\\uC120",
    d: "M51.165,1.94a49.6,49.6,0,0,0-9.923,1,48.945,48.945,0,0,0-17.6,7.406A49.374,49.374,0,0,0,5.807,32.005,48.963,48.963,0,0,0,2.94,41.242a49.724,49.724,0,0,0,0,19.845,48.945,48.945,0,0,0,7.406,17.6A49.374,49.374,0,0,0,32.005,96.523a48.964,48.964,0,0,0,9.237,2.867,49.725,49.725,0,0,0,19.845,0,48.945,48.945,0,0,0,17.6-7.406A49.374,49.374,0,0,0,96.523,70.325a48.964,48.964,0,0,0,2.867-9.237,49.725,49.725,0,0,0,0-19.845,48.945,48.945,0,0,0-7.406-17.6A49.374,49.374,0,0,0,70.325,5.807,48.963,48.963,0,0,0,61.088,2.94a49.6,49.6,0,0,0-9.923-1m0-1.94A51.165,51.165,0,1,1,0,51.165,51.165,51.165,0,0,1,51.165,0Z",
    transform: "translate(-6876.891 2758.933)",
    fill: "#243242"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21990",
    "data-name": "\\uD0C0\\uC6D0 21990",
    cx: 51.165,
    cy: 51.165,
    r: 51.165,
    transform: "translate(-7020.875 2646.224)",
    fill: "#ffeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21775_-_\\uC724\\uACFD\\uC120-3",
    "data-name": "\\uD0C0\\uC6D0 21775 - \\uC724\\uACFD\\uC120",
    d: "M51.165,1.94a49.6,49.6,0,0,0-9.923,1,48.945,48.945,0,0,0-17.6,7.406A49.374,49.374,0,0,0,5.807,32.005,48.963,48.963,0,0,0,2.94,41.242a49.724,49.724,0,0,0,0,19.845,48.945,48.945,0,0,0,7.406,17.6A49.374,49.374,0,0,0,32.005,96.523a48.964,48.964,0,0,0,9.237,2.867,49.725,49.725,0,0,0,19.845,0,48.945,48.945,0,0,0,17.6-7.406A49.374,49.374,0,0,0,96.523,70.325a48.964,48.964,0,0,0,2.867-9.237,49.725,49.725,0,0,0,0-19.845,48.945,48.945,0,0,0-7.406-17.6A49.374,49.374,0,0,0,70.325,5.807,48.963,48.963,0,0,0,61.088,2.94a49.6,49.6,0,0,0-9.923-1m0-1.94A51.165,51.165,0,1,1,0,51.165,51.165,51.165,0,0,1,51.165,0Z",
    transform: "translate(-7020.875 2646.224)",
    fill: "#243242"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21991",
    "data-name": "\\uD0C0\\uC6D0 21991",
    cx: 51.165,
    cy: 51.165,
    r: 51.165,
    transform: "translate(-6876.891 2534.988)",
    fill: "#ffeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21775_-_\\uC724\\uACFD\\uC120-4",
    "data-name": "\\uD0C0\\uC6D0 21775 - \\uC724\\uACFD\\uC120",
    d: "M51.165,1.94a49.6,49.6,0,0,0-9.923,1,48.945,48.945,0,0,0-17.6,7.406A49.374,49.374,0,0,0,5.807,32.005,48.963,48.963,0,0,0,2.94,41.242a49.724,49.724,0,0,0,0,19.845,48.945,48.945,0,0,0,7.406,17.6A49.374,49.374,0,0,0,32.005,96.523a48.964,48.964,0,0,0,9.237,2.867,49.725,49.725,0,0,0,19.845,0,48.945,48.945,0,0,0,17.6-7.406A49.374,49.374,0,0,0,96.523,70.325a48.964,48.964,0,0,0,2.867-9.237,49.725,49.725,0,0,0,0-19.845,48.945,48.945,0,0,0-7.406-17.6A49.374,49.374,0,0,0,70.325,5.807,48.963,48.963,0,0,0,61.088,2.94a49.6,49.6,0,0,0-9.923-1m0-1.94A51.165,51.165,0,1,1,0,51.165,51.165,51.165,0,0,1,51.165,0Z",
    transform: "translate(-6876.891 2534.988)",
    fill: "#243242"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186054",
    "data-name": "\\uADF8\\uB8F9 186054",
    transform: "translate(-6879.731 2581.899)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21780",
    "data-name": "\\uD0C0\\uC6D0 21780",
    cx: 4.083,
    cy: 4.083,
    r: 4.083,
    transform: "translate(0 0)",
    fill: "#87c159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21780_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21780 - \\uC724\\uACFD\\uC120",
    d: "M4.083,1.455A2.629,2.629,0,1,0,6.712,4.083,2.632,2.632,0,0,0,4.083,1.455M4.083,0A4.083,4.083,0,1,1,0,4.083,4.083,4.083,0,0,1,4.083,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186047",
    "data-name": "\\uADF8\\uB8F9 186047",
    transform: "translate(-6923.531 2469.361)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21780-2",
    "data-name": "\\uD0C0\\uC6D0 21780",
    cx: 4.083,
    cy: 4.083,
    r: 4.083,
    transform: "translate(0)",
    fill: "#87c159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21780_-_\\uC724\\uACFD\\uC120-2",
    "data-name": "\\uD0C0\\uC6D0 21780 - \\uC724\\uACFD\\uC120",
    d: "M4.083,1.455A2.629,2.629,0,1,0,6.712,4.083,2.632,2.632,0,0,0,4.083,1.455M4.083,0A4.083,4.083,0,1,1,0,4.083,4.083,4.083,0,0,1,4.083,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186044",
    "data-name": "\\uADF8\\uB8F9 186044",
    transform: "translate(-6880.071 2805.737)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21780-3",
    "data-name": "\\uD0C0\\uC6D0 21780",
    cx: 4.083,
    cy: 4.083,
    r: 4.083,
    transform: "translate(0)",
    fill: "#87c159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21780_-_\\uC724\\uACFD\\uC120-3",
    "data-name": "\\uD0C0\\uC6D0 21780 - \\uC724\\uACFD\\uC120",
    d: "M4.083,1.455A2.629,2.629,0,1,0,6.712,4.083,2.632,2.632,0,0,0,4.083,1.455M4.083,0A4.083,4.083,0,1,1,0,4.083,4.083,4.083,0,0,1,4.083,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186048",
    "data-name": "\\uADF8\\uB8F9 186048",
    transform: "translate(-6923.531 2693.306)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21780-4",
    "data-name": "\\uD0C0\\uC6D0 21780",
    cx: 4.083,
    cy: 4.083,
    r: 4.083,
    transform: "translate(0)",
    fill: "#87c159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21780_-_\\uC724\\uACFD\\uC120-4",
    "data-name": "\\uD0C0\\uC6D0 21780 - \\uC724\\uACFD\\uC120",
    d: "M4.083,1.455A2.629,2.629,0,1,0,6.712,4.083,2.632,2.632,0,0,0,4.083,1.455M4.083,0A4.083,4.083,0,1,1,0,4.083,4.083,4.083,0,0,1,4.083,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186049",
    "data-name": "\\uADF8\\uB8F9 186049",
    transform: "translate(-7013.014 2764.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121770",
    "data-name": "\\uD328\\uC2A4 121770",
    d: "M11980.3,17760.332s-.341,9.5-8.358,10.328c8,.807,8.358,10.438,8.358,10.438s.29-9.6,8.4-10.437C11980.572,17769.75,11980.3,17760.332,11980.3,17760.332Z",
    transform: "translate(-11911.368 -17686.863)",
    fill: "#ffc01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132671",
    "data-name": "\\uD328\\uC2A4 132671",
    d: "M11983.457,17760.334s-.469,13.092-11.514,14.227c11.014,1.109,11.514,14.377,11.514,14.377s.4-13.221,11.57-14.377C11983.832,17773.307,11983.457,17760.334,11983.457,17760.334Z",
    transform: "translate(-11971.943 -17753.783)",
    fill: "#ffc01a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184447",
    "data-name": "\\uADF8\\uB8F9 184447",
    transform: "translate(12.509 14.845)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21766",
    "data-name": "\\uD0C0\\uC6D0 21766",
    cx: 28.166,
    cy: 28.166,
    r: 28.166,
    transform: "translate(1.707 1.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132317",
    "data-name": "\\uD328\\uC2A4 132317",
    d: "M870.273,272.092a29.872,29.872,0,1,1,29.873-29.872A29.907,29.907,0,0,1,870.273,272.092Zm0-56.331a26.458,26.458,0,1,0,26.459,26.458A26.488,26.488,0,0,0,870.273,215.761Z",
    transform: "translate(-840.401 -212.347)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184468",
    "data-name": "\\uADF8\\uB8F9 184468",
    transform: "translate(19.284 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132331",
    "data-name": "\\uD328\\uC2A4 132331",
    d: "M888.046,227.028a23.262,23.262,0,1,0,0,32.891A23.281,23.281,0,0,0,888.046,227.028Z",
    transform: "translate(-848.339 -198.656)",
    fill: "#5eb4e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132332",
    "data-name": "\\uD328\\uC2A4 132332",
    d: "M884.138,233.441a15.962,15.962,0,1,0,0,22.571A15.978,15.978,0,0,0,884.138,233.441Z",
    transform: "translate(-849.591 -199.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132333",
    "data-name": "\\uD328\\uC2A4 132333",
    d: "M879.476,241.094a7.255,7.255,0,1,0,0,10.257A7.261,7.261,0,0,0,879.476,241.094Z",
    transform: "translate(-851.086 -201.402)",
    fill: "#5eb4e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184467",
    "data-name": "\\uADF8\\uB8F9 184467",
    transform: "translate(21.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184462",
    "data-name": "\\uADF8\\uB8F9 184462",
    transform: "translate(24.281 3.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132334",
    "data-name": "\\uD328\\uC2A4 132334",
    d: "M903.536,215.429l-1.936-5.805,10.965-10.967,1.936,5.809Z",
    transform: "translate(-901.6 -198.656)",
    fill: "#f8c44f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132335",
    "data-name": "\\uD328\\uC2A4 132335",
    d: "M903.868,216.426l5.806,1.936L920.638,207.4l-5.8-1.934Z",
    transform: "translate(-901.932 -199.653)",
    fill: "#f8c44f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184465",
    "data-name": "\\uADF8\\uB8F9 184465",
    transform: "translate(22.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184463",
    "data-name": "\\uADF8\\uB8F9 184463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132336",
    "data-name": "\\uD328\\uC2A4 132336",
    d: "M902.454,218.045l-3.144-9.425,13.665-13.666,3.143,9.429Zm.763-8.5.729,2.185,8.267-8.265-.73-2.187Z",
    transform: "translate(-899.311 -194.954)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184464",
    "data-name": "\\uADF8\\uB8F9 184464",
    transform: "translate(0.73 7.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132337",
    "data-name": "\\uD328\\uC2A4 132337",
    d: "M909.593,219.98l-9.427-3.144,13.665-13.662,9.425,3.14Zm-3.108-4.635,2.186.729,8.265-8.267-2.183-.727Z",
    transform: "translate(-900.166 -203.174)",
    fill: "#282d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184466",
    "data-name": "\\uADF8\\uB8F9 184466",
    transform: "translate(0 5.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132338",
    "data-name": "\\uD328\\uC2A4 132338",
    d: "M874.858,242.135a1.707,1.707,0,0,1-1.207-2.914l37.136-37.135A1.707,1.707,0,0,1,913.2,204.5l-37.136,37.135A1.7,1.7,0,0,1,874.858,242.135Z",
    transform: "translate(-873.151 -201.586)",
    fill: "#282d33"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186050",
    "data-name": "\\uADF8\\uB8F9 186050",
    transform: "translate(-7003.016 2548.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186026",
    "data-name": "\\uADF8\\uB8F9 186026",
    transform: "translate(0.813 1.587)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21790",
    "data-name": "\\uD0C0\\uC6D0 21790",
    cx: 23.521,
    cy: 23.521,
    r: 23.521,
    transform: "translate(8.73 12.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21790_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21790 - \\uC724\\uACFD\\uC120",
    d: "M23.521,2.91A20.612,20.612,0,1,0,44.133,23.521,20.635,20.635,0,0,0,23.521,2.91m0-2.91A23.521,23.521,0,1,1,0,23.521,23.521,23.521,0,0,1,23.521,0Z",
    transform: "translate(8.73 12.124)",
    fill: "#282d34"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21787",
    "data-name": "\\uD0C0\\uC6D0 21787",
    cx: 14.307,
    cy: 14.307,
    r: 14.307,
    transform: "translate(0 35.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21788",
    "data-name": "\\uD0C0\\uC6D0 21788",
    cx: 14.307,
    cy: 14.307,
    r: 14.307,
    transform: "translate(36.373 35.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_21789",
    "data-name": "\\uD0C0\\uC6D0 21789",
    cx: 14.307,
    cy: 14.307,
    r: 14.307,
    transform: "translate(17.944)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184852",
    "data-name": "\\uADF8\\uB8F9 184852",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184850",
    "data-name": "\\uADF8\\uB8F9 184850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184848",
    "data-name": "\\uADF8\\uB8F9 184848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167479",
    "data-name": "\\uADF8\\uB8F9 167479",
    transform: "translate(0 36.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118371",
    "data-name": "\\uD328\\uC2A4 118371",
    d: "M308.892,359.07A15.474,15.474,0,1,1,324.365,343.6,15.492,15.492,0,0,1,308.892,359.07Zm0-28.321A12.847,12.847,0,1,0,321.739,343.6,12.862,12.862,0,0,0,308.892,330.748Z",
    transform: "translate(-293.417 -328.122)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118372",
    "data-name": "\\uD328\\uC2A4 118372",
    d: "M304.126,352.145a9.444,9.444,0,0,1-1.716-5.461,9.57,9.57,0,0,1,19.14,0,9.444,9.444,0,0,1-1.716,5.46,5.123,5.123,0,0,0-4.756-3.232h-6.195A5.122,5.122,0,0,0,304.126,352.145Z",
    transform: "translate(-296.505 -294.966)",
    fill: "#5eb4e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118373",
    "data-name": "\\uD328\\uC2A4 118373",
    d: "M349.849,291.941a11.757,11.757,0,1,1-11.757-11.757A11.758,11.758,0,0,1,349.849,291.941Z",
    transform: "translate(-304.721 -275.416)",
    fill: "#ff7bb4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167480",
    "data-name": "\\uADF8\\uB8F9 167480",
    transform: "translate(16.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118374",
    "data-name": "\\uD328\\uC2A4 118374",
    d: "M335.6,305.973a16.525,16.525,0,1,1,16.526-16.526A16.544,16.544,0,0,1,335.6,305.973Zm0-30.424a13.9,13.9,0,1,0,13.9,13.9A13.915,13.915,0,0,0,335.6,275.548Z",
    transform: "translate(-319.072 -272.922)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167481",
    "data-name": "\\uADF8\\uB8F9 167481",
    transform: "translate(27.928 9.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118375",
    "data-name": "\\uD328\\uC2A4 118375",
    d: "M346.212,293.834a4.13,4.13,0,1,1-4.131-4.13A4.131,4.131,0,0,1,346.212,293.834Z",
    transform: "translate(-336.639 -288.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118376",
    "data-name": "\\uD328\\uC2A4 118376",
    d: "M341.394,298.59a5.443,5.443,0,1,1,5.444-5.442A5.449,5.449,0,0,1,341.394,298.59Zm0-8.259a2.816,2.816,0,1,0,2.817,2.817A2.819,2.819,0,0,0,341.394,290.33Z",
    transform: "translate(-335.952 -287.704)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167482",
    "data-name": "\\uADF8\\uB8F9 167482",
    transform: "translate(24.829 18.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118377",
    "data-name": "\\uD328\\uC2A4 118377",
    d: "M343.558,302.982h-6.194a4.131,4.131,0,0,0-4.131,4.13v.336a10.52,10.52,0,0,0,14.455,0v-.336A4.13,4.13,0,0,0,343.558,302.982Z",
    transform: "translate(-331.92 -301.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118378",
    "data-name": "\\uD328\\uC2A4 118378",
    d: "M339.774,310.95a11.818,11.818,0,0,1-8.128-3.233l-.413-.389v-.9a5.45,5.45,0,0,1,5.444-5.443h6.194a5.449,5.449,0,0,1,5.443,5.443v.9l-.413.389A11.811,11.811,0,0,1,339.774,310.95Zm-5.9-4.77a9.2,9.2,0,0,0,11.807,0,2.82,2.82,0,0,0-2.806-2.572h-6.194A2.821,2.821,0,0,0,333.87,306.18Z",
    transform: "translate(-331.233 -300.982)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167483",
    "data-name": "\\uADF8\\uB8F9 167483",
    transform: "translate(10.032 44.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118379",
    "data-name": "\\uD328\\uC2A4 118379",
    d: "M318.956,347.433a4.13,4.13,0,1,1-4.13-4.13A4.13,4.13,0,0,1,318.956,347.433Z",
    transform: "translate(-309.383 -341.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118380",
    "data-name": "\\uD328\\uC2A4 118380",
    d: "M314.139,352.188a5.443,5.443,0,1,1,5.443-5.442A5.449,5.449,0,0,1,314.139,352.188Zm0-8.259a2.816,2.816,0,1,0,2.817,2.817A2.82,2.82,0,0,0,314.139,343.929Z",
    transform: "translate(-308.696 -341.303)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167484",
    "data-name": "\\uADF8\\uB8F9 167484",
    transform: "translate(6.934 53.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118381",
    "data-name": "\\uD328\\uC2A4 118381",
    d: "M321.059,364.788h-2.626v-4.763a2.82,2.82,0,0,0-2.817-2.817h-6.195a2.82,2.82,0,0,0-2.817,2.817v4.763h-2.626v-4.763a5.45,5.45,0,0,1,5.443-5.444h6.195a5.45,5.45,0,0,1,5.443,5.444Z",
    transform: "translate(-303.978 -354.581)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167485",
    "data-name": "\\uADF8\\uB8F9 167485",
    transform: "translate(35.664 36.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118382",
    "data-name": "\\uD328\\uC2A4 118382",
    d: "M363.209,359.07A15.474,15.474,0,1,1,378.683,343.6,15.492,15.492,0,0,1,363.209,359.07Zm0-28.321A12.847,12.847,0,1,0,376.057,343.6,12.862,12.862,0,0,0,363.209,330.748Z",
    transform: "translate(-347.735 -328.122)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118383",
    "data-name": "\\uD328\\uC2A4 118383",
    d: "M358.443,352.145a9.452,9.452,0,0,1-1.716-5.461,9.57,9.57,0,0,1,19.139,0,9.451,9.451,0,0,1-1.716,5.46,5.123,5.123,0,0,0-4.756-3.232h-6.2A5.124,5.124,0,0,0,358.443,352.145Z",
    transform: "translate(-315.158 -294.966)",
    fill: "#5eb4e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167486",
    "data-name": "\\uADF8\\uB8F9 167486",
    transform: "translate(45.696 44.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118384",
    "data-name": "\\uD328\\uC2A4 118384",
    d: "M373.273,347.433a4.13,4.13,0,1,1-4.13-4.13A4.13,4.13,0,0,1,373.273,347.433Z",
    transform: "translate(-363.7 -341.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118385",
    "data-name": "\\uD328\\uC2A4 118385",
    d: "M368.456,352.188a5.443,5.443,0,1,1,5.443-5.442A5.449,5.449,0,0,1,368.456,352.188Zm0-8.259a2.816,2.816,0,1,0,2.817,2.817A2.82,2.82,0,0,0,368.456,343.929Z",
    transform: "translate(-363.013 -341.303)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167487",
    "data-name": "\\uADF8\\uB8F9 167487",
    transform: "translate(42.598 53.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118386",
    "data-name": "\\uD328\\uC2A4 118386",
    d: "M375.376,364.788H372.75v-4.763a2.82,2.82,0,0,0-2.816-2.817h-6.2a2.82,2.82,0,0,0-2.817,2.817v4.763h-2.626v-4.763a5.45,5.45,0,0,1,5.443-5.444h6.2a5.449,5.449,0,0,1,5.442,5.444Z",
    transform: "translate(-358.295 -354.581)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167488",
    "data-name": "\\uADF8\\uB8F9 167488",
    transform: "translate(32.058 31.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118387",
    "data-name": "\\uD328\\uC2A4 118387",
    d: "M344.242,313.915v0Z",
    transform: "translate(-342.929 -313.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_150940",
    "data-name": "\\uC0AC\\uAC01\\uD615 150940",
    width: 2.626,
    height: 8.002,
    transform: "translate(0 0)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167491",
    "data-name": "\\uADF8\\uB8F9 167491",
    transform: "translate(25.179 37.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167489",
    "data-name": "\\uADF8\\uB8F9 167489",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118388",
    "data-name": "\\uD328\\uC2A4 118388",
    d: "M332.766,335.631l7.291-4.211Z",
    transform: "translate(-332.109 -330.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_150941",
    "data-name": "\\uC0AC\\uAC01\\uD615 150941",
    width: 8.42,
    height: 2.626,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 4.21)",
    fill: "#282d33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167490",
    "data-name": "\\uADF8\\uB8F9 167490",
    transform: "translate(7.777 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_118389",
    "data-name": "\\uD328\\uC2A4 118389",
    d: "M351.9,335.631l-7.293-4.211Z",
    transform: "translate(-343.954 -330.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_150942",
    "data-name": "\\uC0AC\\uAC01\\uD615 150942",
    width: 2.626,
    height: 8.421,
    transform: "translate(0 2.274) rotate(-59.999)",
    fill: "#282d33"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitProcessesImage);
export default __webpack_public_path__ + "static/media/mobile_recruit_processes_image.be6477beba4311e2c013a93c94d28971.svg";
export { ForwardRef as ReactComponent };